import produce from 'immer';
import { StateProps } from './interface';
import {
    initStoreHandler,
    captchaResponseHandler,
    changeInputHandler,
    lmsResponseHandler,
} from './helpers/reducer.helper';
import { Actions } from './action';
import { ActionType } from './enum';

export const initialState: StateProps = {
    loading: false,
    error: undefined,
    formData: {},
    responseData: undefined,
    captcha: undefined,
};

const appReducer = (state = initialState, action: Actions) =>
    produce(state, draft => {
        switch (action.type) {
            case ActionType.INIT_STORE:
                initStoreHandler(draft, action.state);
                break;
            case ActionType.GET_CAPTCHA:
                draft.loading = true;
                break;
            case ActionType.HANDLE_CAPTCHA_RESPONSE:
                captchaResponseHandler(draft, action);
                break;
            case ActionType.CHANGE_INPUT:
                changeInputHandler(draft, state, action);
                break;
            case ActionType.SUBMIT_FORM:
                draft.loading = true;
                break;
            case ActionType.HANDLE_LMS_RESPONSE:
                lmsResponseHandler(draft, action);
                break;
        }
    });

export default appReducer;
